import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";

import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import ContributionPresenter from "./ContributionPresenter";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";
class ContributionsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ContributionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      limit: 50,
      current: 1,
      count: 0,
      object: {},
      selectedItem: [],
      selectedType: "",
      month: "",
      count: "",
      contributions: [],
    };
  }

  getCollectionName() {
    return "employees";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const user = this.getCurrentUser();
    const contributionsType = await findObjectUseCase().execute(
      "contribution_type"
    );
    const contributions = contributionsType.map(
      (item) => item.contributionType
    );

    const { objects } = this.state;

    this.setState({ contributions });
    // await this.refetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("PREV STATET", prevState);
    if (prevState.selectedItem !== this.state.selectedItem) {
      console.log("TRUEEEE");
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async refetchData() {
    const objects = await findObjectUseCase().execute(this.getCollectionName());
    this.setState({ objects, count: objects.length });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      loading,
      selectedType,
      count,
      limit,
      current,
      contributions,
      selectedItem,
      filters,
    } = this.state;

    console.log("SELECTEDDDD ITEM", selectedItem);

    console.log("objects", objects);

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "surname" &&
        fields !== "Middlename" &&
        fields !== "Firstname" &&
        fields !== "mandatoryDeductions"
    );

    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Finance {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Contributions
                  </span>
                </p>
              </div>
              <CardView>
                <div className="row">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        field === "Firstname" ||
                        field === "Middlename" ||
                        field === "surname"
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.presenter._onChangeFilter.bind(
                              this,
                              type
                            )}
                            {...options}
                          />
                        </div>
                      );
                    })}
                  <div className="col-lg-12 p-1">
                    <SearchSelect
                      value={selectedType}
                      placeholder="Select Contribution to display"
                      onChange={(value) =>
                        this.presenter._onSelect("selectedType", value)
                      }
                      onClickClear={() =>
                        this.presenter._onSelect("selectedType", "")
                      }
                      options={contributions.map((contributions) => ({
                        label: contributions,
                        value: contributions,
                      }))}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center ">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex flex-row align-items-center justify-content-center gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <SearchSelect
                        value={this.state.month}
                        onChange={(value) =>
                          this.presenter._onSelect("month", value)
                        }
                        onClickClear={() =>
                          this.presenter._onSelect("month", "")
                        }
                        options={months.map((month) => ({
                          label: month,
                          value: month,
                        }))}
                      />
                      <Button
                        onClick={() =>
                          this.presenter._handleExportCsv(includeLabel, objects)
                        }
                      >
                        <i className="bi bi-arrow-down-circle"></i> Export CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                progress={loading}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      // case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
                selectedItem={selectedItem}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default ContributionsPage;
